import StyleEditor from './StyleEditor'
export default StyleEditor



/** WEBPACK FOOTER **
 ** ./src/Editors/StyleEditor/index.js
 **/